// extracted by mini-css-extract-plugin
export default {"reportPills":"ReportPills_reportPills__ITMvX","pill":"ReportPills_pill__siqSU","pillValue":"ReportPills_pillValue__DDfbL","multiple":"ReportPills_multiple__qm1i5"};